import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { setAppError } from './app'
import { MOBILE_OPERATORS } from '../constants'

export const getMobileOperators = createAsyncThunk(
  'mobileOperators/getMobileOperators',
  async (payload, thunkAPI) => {
    const { dispatch } = thunkAPI
    try {
      const response = await axios.get(`${MOBILE_OPERATORS}`)
      return response.data.operators
    } catch (error) {
      dispatch(
        setAppError({ error: true, message: 'Error on list currencies' })
      )
    }
  }
)

export const initialState = {
  list: [],
}
export const mobileOperators = createSlice({
  name: 'mobileOperators',
  initialState,
  reducers: {
    addMobileOperators: (state, action) => {
      const { payload } = action
      state.list = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMobileOperators.fulfilled, (state, action) => {
      const { payload } = action
      state.list = payload
    })
  },
})

export const { addMobileOperators } = mobileOperators.actions

export default mobileOperators.reducer
